// removed by extract-text-webpack-plugin
module.exports = {"leadBackgroundImage":"src-templates----blog-post-module---leadBackgroundImage---RxIr2","storyHeadline":"src-templates----blog-post-module---storyHeadline---1319e","introContainer":"src-templates----blog-post-module---introContainer---Fb3_9","storyContent":"src-templates----blog-post-module---storyContent---2hsVT"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/blog-post.module.css
// module id = 330
// module chunks = 241083017184588